import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Alert, Button, Col, Row, Spinner } from 'react-bootstrap';

export default function ConfirmAlert(props) {
  let { title, body, onConfirm, onClose, visible, confirmBtnText, cancelBtnText, confirmLoading } = props;

  return (
    <Modal
      isOpen={visible}
      style={{
        overlay: { zIndex: 100, backgroundColor: 'rgba(0, 0, 0, 0.75)' },
        content: { backgroundColor: 'transparent', border: 'none' },
      }}
    >
      <Row className={'justify-content-center'}>
        <Col lg={4}>
          <Alert className={'flex-column'} variant={'secondary'}>
            <Alert.Heading>{title}</Alert.Heading>
            <p>{body}</p>
            <hr />
            <div className={'d-flex justify-content-end'}>
              <Button onClick={onConfirm} variant={'outline-danger'} disabled={confirmLoading}>
                {confirmLoading ? <Spinner animation={'border'} /> : confirmBtnText}
              </Button>
              <Button onClick={onClose} className={'ml-2'} variant={'outline-secondary'}>
                {cancelBtnText}
              </Button>
            </div>
          </Alert>
        </Col>
      </Row>
    </Modal>
  );
}

ConfirmAlert.defaultProps = {
  visible: false,
  onClose: () => {},
  title: '',
  body: '',
  variant: 'danger',
  confirmBtnText: 'ثبت نهایی',
  cancelBtnText: 'لغو',
  confirmLoading: false,
};

ConfirmAlert.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'success', 'info', 'warning', 'danger', 'link']),
  onConfirm: PropTypes.func.isRequired,
  confirmBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
  confirmLoading: PropTypes.bool,
};
